import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SdsRequestService {

  baseUrl = environment.apiUrl;

constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    const securityToken = localStorage.getItem('token');
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (securityToken) {
      headers = headers.set('authorization', `Bearer ${securityToken}`);
    }
    return headers;
  }

  calgaryTopHealthAuthority(userOutSideId: any) {
    const httpHeaders = this.getHeaders();
    return this.http.get(this.baseUrl + 'SDSRequest/UserTopLocToDisplay/' + userOutSideId, { headers: httpHeaders });
  }

  getLocation(locationId: any) {
    const httpHeaders = this.getHeaders();
    return this.http.get(this.baseUrl + 'SDSRequest/Location/' + locationId, { headers: httpHeaders });
  }
}